import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AccessConfig } from '../interfaces/access-config.interface';
import { ROUTES } from '../constants/routes';
import { AlertMessagingService } from '../services/alert-messaging.service';
import { AuthService } from '../services/auth.service';

export const commonAccessGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService = inject(AuthService);
  const alertService = inject(AlertMessagingService);
  const router = inject(Router);

  const {
    allowedRoles = [],
    allowedTasks = [],
    restrictedRoles = [],
    restrictedTasks = [],
  }: AccessConfig = route.data;

  const roles = authService.getUserRoles();
  const tasks = authService.getUserTasks();

  if (restrictedTasks.length && hasMatch(tasks, restrictedTasks)) return deny(alertService, router);
  if (restrictedRoles.length && hasMatch(roles, restrictedRoles)) return deny(alertService, router);

  if (!allowedRoles.length && !allowedTasks.length) return true;

  if (hasMatch(roles, allowedRoles) || hasMatch(tasks, allowedTasks)) return true;

  return deny(alertService, router);
};

function hasMatch(assigned: string[], required: string[]): boolean {
  return assigned.some((item) => required.includes(item));
}

function deny(alertService: AlertMessagingService, router: Router) {
  alertService.error('You do not have access to this page.');
  return router.createUrlTree([ROUTES.DASHBOARD.fullPath]);
}
